export const COLORS = {
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    BROWN_1: '#907C4B',
    GRAY_1: '#1C1C1B',
    GRAY_2: '#717171',
    GRAY_3: '#A4A4A4',
    GRAY_4: '#C4C4C4',
    GRAY_4A: '#B3B3B3',
    GRAY_5: '#F2F2F2',
    GRAY_5A: '#999999',
    GRAY_BACKGROUND: '#F8F8F8',
    GOLD: '#FFDA2D',
    SILVER: '#ADB3B7',
    BRONZE: '#D58D54',
    RED_1: '#DD0000',
    GREEN: '#51BC2B',
    TRANSPARENT: 'transparent',
    _2C2F35: '#2C2F35',
    _FFFFFF: '#FFFFFF',
    _F3F5F8: '#F3F5F8',
    _858991: '#858991',
    _15171C: '#15171c',
    _EAECF1: '#EAECF1',
    _C6CAD1: '#C6CAD1',
    _787B83: '#787B83',
    _1CBA4C: '#1CBA4C',
    _17963D: '#17963D',
    _00A8FF: '#00A8FF',
    _0090DB: '#0090DB',
    _A55EEA: '#A55EEA',
    _8C50C7: '#8C50C7',
    _FFAA34: '#FFAA34',
    _DB922D: '#DB922D',
    _9EA2AA: '#9EA2AA',
    _E84118: '#E84118',
    _CF3A15: '#cf3a15',
    _175CE5: '#175CE5',
    _6C6F76: '#6C6F76',
    _474A50: '#474a50',
};
